export default {
  joboffers: [],
  filters: {},
  content: null,
  currentJoboffer: null,
  currentJobDetails: null
};
